import PreviewModal from "./PreviewModal";
import UserCard from "../../UserCard";
import EditableCardEntryPhone from "../../editable_entries/EditableCardEntryPhone";
import EditableCardEntryInput from "../../editable_entries/EditableCardEntryInput";
import SimpleEvenFlex from "../../cards/SimpleEvenFlex";
import EditableCardEntryEmail from "../../editable_entries/EditableCardEntryEmail";


/**
 * @param param0
 * @param param0.user {SC_User}
 * @param param0.linkContent
 * @param param0.fancy
 * @return {JSX.Element}
 * @constructor
 */
const UserPreviewModal = ({user, linkContent, fancy = false}) => {
    if (fancy)
        return <SimpleEvenFlex fullWidth={true} growUp={false} enforceEven={true} extraStyle={{marginTop: "0.25rem"}}>
            <PreviewModal linkContent={<EditableCardEntryInput type={"text"} displayLabel={"Name"} baseValue={linkContent ?? user.name} isEditing={false}/> } modalTitle={`Viewing ${user.name}`}>
                <UserCard user={user} />
            </PreviewModal>
            <EditableCardEntryPhone
                isEditing={false}
                displayLabel={"Phone"}
                baseValue={user.phone}
                hyperlinkDisplay={true}
            />
            <EditableCardEntryEmail

                isEditing={false}
                displayLabel={"Email"}
                baseValue={user.email}
                hyperlinkDisplay={true}
            />
        </SimpleEvenFlex>
    return <PreviewModal linkContent={linkContent ?? user.name} modalTitle={`Viewing ${user.name}`}>
        <UserCard user={user} />
    </PreviewModal>
}

export default UserPreviewModal;